import serverCall from "../serverCall";

// All countries with their cross-check coverage flag + sent count.
// Backend: GET /admin/countries.
const getCountries = () => {
  return serverCall.get(`/admin/countries`);
};

// Enable/disable CROSS-CHECK coverage for a country (the paid verification fallback
// only fires where this is on). Backend: POST /admin/country/cross-check.
const setCrossCheck = (country, enabled) => {
  return serverCall.post(
    `/admin/country/cross-check?country=${encodeURIComponent(country)}&enabled=${enabled}`
  );
};

// Bulk enable/disable for many ISO country codes at once (multi-select / enable-all).
// Backend: POST /admin/country/cross-check-bulk.
const setCrossCheckBulk = (countries, enabled) => {
  return serverCall.post(`/admin/country/cross-check-bulk`, { countries, enabled });
};

// Set a country's daily cross-check send quota (0 = system default).
// Backend: POST /admin/country/cross-check-quota.
const setQuota = (country, quota) => {
  return serverCall.post(
    `/admin/country/cross-check-quota?country=${encodeURIComponent(country)}&quota=${quota}`
  );
};

// Set a country's verification policy (auth mode).
// Backend: POST /admin/country/verify-mode.  mode ∈ SELF_ONLY|CROSS_ONLY|SELF_AND_CROSS|SELF_TO_VIRTUAL
const setVerifyMode = (country, mode) => {
  return serverCall.post(
    `/admin/country/verify-mode?country=${encodeURIComponent(country)}&mode=${encodeURIComponent(mode)}`
  );
};

// Set a country's SELF_TO_VIRTUAL destination number (blank clears -> global VIRTUAL_NUMBER env).
// Backend: POST /admin/country/virtual-number.
const setVirtualNumber = (country, virtualNumber) => {
  return serverCall.post(
    `/admin/country/virtual-number?country=${encodeURIComponent(country)}&virtualNumber=${encodeURIComponent(
      virtualNumber || ""
    )}`
  );
};

// Set a country's MAX cross-checks per DEVICE per 24h (AIT cap; 0 = system default).
// Backend: POST /admin/country/max-cross-per-device.
const setMaxCrossPerDevice = (country, max) => {
  return serverCall.post(
    `/admin/country/max-cross-per-device?country=${encodeURIComponent(country)}&max=${max}`
  );
};

const CountriesService = {
  getCountries,
  setCrossCheck,
  setCrossCheckBulk,
  setQuota,
  setVerifyMode,
  setVirtualNumber,
  setMaxCrossPerDevice,
};

export default CountriesService;
